import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ICONS } from '@/constants/icons';


export default /*#__PURE__*/_defineComponent({
  props: {
  disabled: Boolean,
  name: String,
  size: String,
  color: String,
  noHover: { type: Boolean, default: false },
  onClick: Function,
  gradient: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props



const getIconName = () => {
  return ICONS[props.name];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button-control-icon", {
      'button-gradient': __props.gradient,
      'text-gray': __props.disabled,
      'not-allowed': __props.disabled,
    }]),
    style: _normalizeStyle([__props.size ? { width: __props.size + 'px', height: __props.size + 'px' } : '']),
    innerHTML: getIconName(),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (!__props.disabled && __props.onClick()))
  }, null, 14, _hoisted_1))
}
}

})